var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTech(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.001 18.0176H6.00098L6.00098 38.0176H42.001V18.0176ZM6.00098 14.0176C3.79184 14.0176 2.00098 15.8084 2.00098 18.0176V38.0176C2.00098 40.2267 3.79184 42.0176 6.00098 42.0176H42.001C44.2101 42.0176 46.001 40.2267 46.001 38.0176V18.0176C46.001 15.8084 44.2101 14.0176 42.001 14.0176H6.00098Z",
    fill: "#15D4B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.001 34.0176C16.001 32.913 16.8964 32.0176 18.001 32.0176H30.001C31.1055 32.0176 32.001 32.913 32.001 34.0176C32.001 35.1221 31.1055 36.0176 30.001 36.0176H18.001C16.8964 36.0176 16.001 35.1221 16.001 34.0176Z",
    fill: "#15D4B6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00098 22.0176C8.00098 20.913 8.89641 20.0176 10.001 20.0176H12.001C13.1055 20.0176 14.001 20.913 14.001 22.0176C14.001 23.1221 13.1055 24.0176 12.001 24.0176H10.001C8.89641 24.0176 8.00098 23.1221 8.00098 22.0176Z",
    fill: "#15D4B6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.001 22.0176C18.001 20.913 18.8964 20.0176 20.001 20.0176H22.001C23.1055 20.0176 24.001 20.913 24.001 22.0176C24.001 23.1221 23.1055 24.0176 22.001 24.0176H20.001C18.8964 24.0176 18.001 23.1221 18.001 22.0176Z",
    fill: "#15D4B6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.001 22.0176C26.001 20.913 26.8964 20.0176 28.001 20.0176H30.001C31.1055 20.0176 32.001 20.913 32.001 22.0176C32.001 23.1221 31.1055 24.0176 30.001 24.0176H28.001C26.8964 24.0176 26.001 23.1221 26.001 22.0176Z",
    fill: "#15D4B6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.001 22.0176C34.001 20.913 34.8964 20.0176 36.001 20.0176H38.001C39.1055 20.0176 40.001 20.913 40.001 22.0176C40.001 23.1221 39.1055 24.0176 38.001 24.0176H36.001C34.8964 24.0176 34.001 23.1221 34.001 22.0176Z",
    fill: "#15D4B6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.001 28.0176C18.001 26.913 18.8964 26.0176 20.001 26.0176H22.001C23.1055 26.0176 24.001 26.913 24.001 28.0176C24.001 29.1221 23.1055 30.0176 22.001 30.0176H20.001C18.8964 30.0176 18.001 29.1221 18.001 28.0176Z",
    fill: "#15D4B6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00098 28.0176C8.00098 26.913 8.89641 26.0176 10.001 26.0176H12.001C13.1055 26.0176 14.001 26.913 14.001 28.0176C14.001 29.1221 13.1055 30.0176 12.001 30.0176H10.001C8.89641 30.0176 8.00098 29.1221 8.00098 28.0176Z",
    fill: "#15D4B6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.001 28.0176C26.001 26.913 26.8964 26.0176 28.001 26.0176H30.001C31.1055 26.0176 32.001 26.913 32.001 28.0176C32.001 29.1221 31.1055 30.0176 30.001 30.0176H28.001C26.8964 30.0176 26.001 29.1221 26.001 28.0176Z",
    fill: "#15D4B6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.001 28.0176C34.001 26.913 34.8964 26.0176 36.001 26.0176H38.001C39.1055 26.0176 40.001 26.913 40.001 28.0176C40.001 29.1221 39.1055 30.0176 38.001 30.0176H36.001C34.8964 30.0176 34.001 29.1221 34.001 28.0176Z",
    fill: "#15D4B6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.001 34.0176C34.001 32.913 34.8964 32.0176 36.001 32.0176H38.001C39.1055 32.0176 40.001 32.913 40.001 34.0176C40.001 35.1221 39.1055 36.0176 38.001 36.0176H36.001C34.8964 36.0176 34.001 35.1221 34.001 34.0176Z",
    fill: "#15D4B6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00098 34.0176C8.00098 32.913 8.89641 32.0176 10.001 32.0176H12.001C13.1055 32.0176 14.001 32.913 14.001 34.0176C14.001 35.1221 13.1055 36.0176 12.001 36.0176H10.001C8.89641 36.0176 8.00098 35.1221 8.00098 34.0176Z",
    fill: "#15D4B6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.001 4.01758C31.1055 4.01758 32.001 4.91301 32.001 6.01758V7.01758C32.001 9.779 29.7624 12.0176 27.001 12.0176C26.4487 12.0176 26.001 12.4653 26.001 13.0176V14.0176C26.001 15.1221 25.1055 16.0176 24.001 16.0176C22.8964 16.0176 22.001 15.1221 22.001 14.0176V13.0176C22.001 10.2562 24.2396 8.01758 27.001 8.01758C27.5533 8.01758 28.001 7.56986 28.001 7.01758V6.01758C28.001 4.91301 28.8964 4.01758 30.001 4.01758Z",
    fill: "#15D4B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTech);
export default __webpack_public_path__ + "static/media/iconTech.9dc0a26066b408108ae63fcdaf5efc40.svg";
export { ForwardRef as ReactComponent };